import React, { ImgHTMLAttributes, MouseEventHandler } from 'react';
import Image from 'next/image';
import styles from './styles.module.scss';

type LoaderProps = {
  src: string;
};

type AppImageProps = {
  blurDataURL?: string;
  placeholder?: 'blur' | 'empty';
  src?: string | null;
  alt?: string;
  height?: number | `${number}` | undefined;
  width?: number | `${number}` | undefined;
  unoptimized?: boolean;
  layout?: string;
  onClick?: MouseEventHandler<HTMLImageElement>;
  className?: string;
  containerclassName?: string;
  text?: string;
  toolTipClassName?: string;
  toolTip?: string;
  textStyle?: string;
  title?: string;
  titleStyle?: string;
  large?: boolean;
  id?: string;
  objectFit?: string;
  objectPosition?: string;
  fill?: boolean;
  mode?: string;
} & ImgHTMLAttributes<HTMLImageElement>;

const AppImage: React.FC<AppImageProps> = ({
  blurDataURL = '/imgs/blur.webp',
  placeholder = 'blur',
  src = '/imgs/blur.webp',
  alt = 'image',
  height = 300,
  width = 300,
  unoptimized = false,
  layout,
  onClick,
  className = '',
  containerclassName = '',
  text = '',
  toolTipClassName = '',
  toolTip = '',
  textStyle = 'nothing',
  title = '',
  titleStyle,
  large = false,
  id = '',
  objectFit = 'cover',
  objectPosition = '',
  fill = null,
  mode = '',
  ...rest
}) => {
  return (
    <div
      className={`${styles.containerclassName} ${mode == 'imageBorder' && styles.imageBorder} ${containerclassName}`}
    >
      <Image
        {...rest}
        src={
          src?.startsWith('/imgs/')
            ? src
            : src?.startsWith('http')
              ? src
              : `${process.env.IMAGE_URL}${src}`
        }
        alt={alt}
        height={height}
        width={width}
        className={`${className} `}
        onClick={onClick}
        id={id}
        unoptimized={true}
      />
    </div>
  );
};

export default AppImage;
